import { HubConnectionBuilder } from "@microsoft/signalr";
import axios from "axios";
import { messengerRequest } from "Auth/auth-config";
const Socket = {
  connect,
  emit,
  on,
  removeListener,
  disconnect,
  socket: {},
};

function start(config) {
  if (Socket.socket) {
    const data = {};

    config &&
      Socket.socket[config.DEVICE_ID]
        .start({ withCredentials: false })
        .then((response) => {
          axios
            .post(
              `${config.STREAMER_URL}/api/addToGroup?groupName=${config.DEVICE_ID}&userId=${config.DEVICE_ID}${config.user.homeAccountId}`,
              data,
              { scope: messengerRequest }
            )
            .catch((error) => {
              console.log(error);
            });

          console.log("SignalR Started");
        })
        .catch((error) => {
          console.log(`Error connecting SignalR -${error}`);
          setTimeout(() => start(), 5000);
        });
  }
}

function connect(config) {
  if (config) {
    const headers = {
      "x-ms-signalr-userid": `${config.DEVICE_ID}${config.user.homeAccountId}`,
    };
    const socketUrl = config.STREAMER_URL + "/api";
    Socket.socket[config.DEVICE_ID] = new HubConnectionBuilder()
      //.withUrl(socketUrl)
      // .configureLogging(1)
      .withUrl(socketUrl, {
        accessTokenFactory: () => config.accessToken,
        headers,
      })
      .build();
    start(config);
  }
}

function on(eventName, callback, systemId) {
  if (Socket.socket) {
    Socket.socket[systemId].on(eventName, (data) => {
      callback(JSON.parse(data)); // SignalR send strings not objects
    });
  }
}

function emit(eventName, data, systemId) {
  if (Socket.socket) {
    Socket.socket[systemId].invoke(eventName, data);
  }
}

// function removeListener(eventName, systemId) {
//   if (Socket.socket[systemId]) {
//     Socket.socket[systemId].off(eventName);
//   }
// }


function removeListener(eventName, callback, systemId) {
  if (Socket.socket?.[systemId]) {
    Socket.socket[systemId].off(eventName, callback);
  }
}

function disconnect(config) {
  if (Socket.socket) {
    const data = {};
    axios
      .post(
        `${config.STREAMER_URL}/api/removeFromGroup?groupName=${config.DEVICE_ID}&userId=${config.DEVICE_ID}${config.user.homeAccountId}`,
        data,
        { scope: messengerRequest }
      )
      .catch((error) => {
        console.log(error);
      });
    Socket.socket[config.DEVICE_ID].stop();
  }
}

export default Socket;
